import React, { useState } from "react";
import "../styles/DisclaimerPopup.css";

function DisclaimerPopup() {
  const [accepted, setAccepted] = useState(false);
  const [consent, setConsent] = useState(false);

  if (consent) return null;

  return (
    <div className="popup">
      <div className="popup-content">
        <h2>Disclaimer</h2>
        <p>
          In accordance with the rules of the Bar Council of India, law firms are prohibited from soliciting work and advertising. By accessing this website (www.nyayom.com), you acknowledge and agree that there has been no advertisement, solicitation, invitation, or inducement from us or any of our members to solicit work through this website. The use of this site does not create a lawyer-client relationship and should not be construed as an invitation to form such a relationship or as legal advice.
        </p>
        <p>
          The information on this website is provided for general informational purposes only. We do not guarantee that the content is current, complete, or accurate. We are not responsible for any consequences resulting from actions taken by users based on the information provided on this website.
        </p>

        {/* Checkbox */}
        <div className="consent-checkbox">
          <input
            type="checkbox"
            id="consent"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <label htmlFor="consent">I accept/consent to the above terms</label>
        </div>

        {/* Proceed button (disabled until checkbox is checked) */}
        <button
          onClick={() => setConsent(true)}
          disabled={!accepted}
          className="proceed-btn"
        >
          Proceed to Website
        </button>
      </div>
    </div>
  );
}

export default DisclaimerPopup;
